import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-generate-identifiers"
// This controller manages the auto-generate identifiers checkbox behavior
// When enabled, it hides the relationship section and auto-selects "Auto-generate" for relevant fields
export default class extends Controller {
  static targets = ["checkbox", "autoGenerateField", "autoGenerateSelect", "relationshipSection", "relationshipInput"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isChecked = this.checkboxTarget.checked

    // Toggle visibility of relationship section
    if (this.hasRelationshipSectionTarget) {
      if (isChecked) {
        this.relationshipSectionTarget.classList.add("hidden")
      } else {
        this.relationshipSectionTarget.classList.remove("hidden")
      }
    }

    // Handle auto-generate select fields
    if (this.hasAutoGenerateSelectTarget) {
      this.autoGenerateSelectTargets.forEach((select) => {
        if (isChecked) {
          // Find and select the "Auto-generate" option (empty value)
          const autoGenerateOption = Array.from(select.options).find(opt => opt.value === "")
          if (autoGenerateOption) {
            select.value = ""
          }
          select.disabled = true
        } else {
          select.disabled = false
        }
      })
    }

    // Clear relationship inputs when auto-generate is enabled
    if (isChecked && this.hasRelationshipInputTarget) {
      this.relationshipInputTargets.forEach((input) => {
        input.value = ""
      })
    }

    // Dispatch a custom event so form-validation controller can update
    this.element.dispatchEvent(new CustomEvent("auto-generate-changed", {
      bubbles: true,
      detail: { enabled: isChecked }
    }))
  }
}
